import { Link } from 'react-router-dom';

// Shared "Action" footer: a high-contrast CTA block plus a clean link row.
export default function SiteFooter({ ctaTitle, ctaButton, ctaTo, ctaHref }) {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-cta" data-reveal>
          <h2 className="h2" style={{ maxWidth: '18ch', margin: '0 auto 2rem' }}>{ctaTitle}</h2>
          {ctaTo ? (
            <Link to={ctaTo} className="btn btn-primary">{ctaButton}</Link>
          ) : (
            <a href={ctaHref} className="btn btn-primary">{ctaButton}</a>
          )}
        </div>
        <div className="footer-row">
          <span>&copy; {new Date().getFullYear()} Pot Belly Pig Studios</span>
          <span style={{ display: 'flex', gap: '1.4rem' }}>
            <Link to="/slope-sliders">Slope Sliders</Link>
            <Link to="/privacy-policy">Privacy &amp; Terms</Link>
            <a href="mailto:support@potbellypigstudios.com">Contact</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
